import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import UnitOptimizerTableDto from '../dto/UnitOptimizerTableDto';

class UnitOptimizerTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'unitOptimizerTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<UnitOptimizerTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, UnitOptimizerTableDto)))
				.catch(reject);
		});
	}
}

export default new UnitOptimizerTableService();
